import _CircularProgress from "@material-ui/core/esm/CircularProgress";
import _Divider from "@material-ui/core/esm/Divider";
import _useMediaQuery from "@material-ui/core/esm/useMediaQuery";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : "" + key, ref: null, props: props, _owner: null }; }

import { useTheme } from '@material-ui/styles';
import Pagination from '@material-ui/lab/Pagination';
import PaginationItem from '@material-ui/lab/PaginationItem';
import React from 'react';
import { User } from "./User";
import { useStyles } from "./UserListStyles";
import { SearchInput } from "./SearchInput";
import { useNotifications } from "../../Notifications";
import { Errors } from "../../Errors";

var _ref3 = /*#__PURE__*/_jsx(_CircularProgress, {
  color: "primary"
});

var _ref4 = /*#__PURE__*/_jsx("span", {}, void 0, "No hay usuarios conectados");

var _ref5 = /*#__PURE__*/_jsx("div", {}, void 0, _jsx(Errors, {}));

export const UserList = _ref => {
  let users = _ref.users,
      pagination = _ref.pagination,
      setSearchValue = _ref.setSearchValue,
      searchValue = _ref.searchValue;
  const classes = useStyles();
  const theme = useTheme();

  const xsDown = _useMediaQuery(theme.breakpoints.down('xs'));

  const _useNotifications = useNotifications(),
        notifications = _useNotifications.notifications;

  return React.createElement(React.Fragment, null, (users?.length !== 0 || searchValue !== '') && _jsx(SearchInput, {
    onChange: setSearchValue
  }), _jsx("div", {
    className: classes.container,
    id: "userListContainer"
  }, void 0, users?.length ? [...(pagination.page === 1 ? notifications : []), ...users.filter(user => !notifications.some(notification => notification.id === user.id))].map((user, index, _ref2) => {
    let length = _ref2.length;
    return React.createElement(React.Fragment, null, _jsx(User, {
      user: user
    }), index !== length - 1 && _jsx(_Divider, {
      className: classes.divider
    }));
  }) : !users ? _jsx("div", {
    className: classes.noUsersContainer
  }, void 0, _ref3) : _jsx("div", {
    className: classes.noUsersContainer
  }, void 0, _ref4)), users?.length !== 0 && React.createElement(Pagination, _extends({
    size: xsDown ? 'small' : 'medium',
    classes: {
      root: classes.pagination
    },
    renderItem: props => React.createElement(PaginationItem, _extends({}, props, {
      classes: {
        icon: classes.paginationIcon
      }
    }))
  }, pagination)), _ref5);
};